import { Empty } from 'antd';
import styled from 'styled-components';

export default styled(Empty)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
